/**
 * Custom Functions for Excel Allocator Plugin
 * All functions use the ALLOCATOR_ namespace (prefix)
 */

/**
 * ALLOCATOR_TEST - Simple test function that returns the input value
 * @customfunction
 * @param {any} input - Any input value
 * @returns {any} The same input value
 */
function TEST(input) {
  console.log('[ALLOCATOR_TEST] Called with input:', input);
  return input;
}

// Register function with Excel
CustomFunctions.associate("TEST", TEST);

